import type { QueryResultSource } from './query-result-source';

export interface RoutingQueryResultSourceOptions {
  /** `true` si el modelo tiene una fuente ejecutable en el servidor. */
  readonly isLive: (semanticModelId: string) => boolean;
  readonly live: QueryResultSource;
  readonly preview: QueryResultSource;
}

/**
 * Elige la fuente por modelo: los modelos del servidor se ejecutan en vivo y los de
 * demostracion usan el preview. Un error de la ejecucion real se devuelve tal cual.
 */
export function createRoutingQueryResultSource(
  options: RoutingQueryResultSourceOptions,
): QueryResultSource {
  return {
    kind: 'routing',
    modeFor: (semanticModelId) => (options.isLive(semanticModelId) ? 'live' : 'preview'),
    load: (plan, loadOptions) =>
      (options.isLive(plan.semanticModelId) ? options.live : options.preview).load(
        plan,
        loadOptions,
      ),
  };
}
